__turbopack_context__.v({
  "className": "BRo1Za_className",
  "variable": "BRo1Za_variable",
});
